import React, { useCallback, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { req } from '../../util'

export const CarReport = () => {

    const [cars, setCars] = useState([])

    const getCars = useCallback(async () => {
        let { success, data } = await req("GET", "car/report/ready")
        if (success && data.length > 0) setCars(data)
    }, [])


    useEffect(() => {
        getCars()
    }, [getCars])

    return (
        <div className="container mx-auto p-4">
            <div className="text-center text-lg text-gray-800 font-semibold">
                العجلات الجهازة لكتابة التقرير
            </div>
            <div className="flex flex-wrap justify-center m-2">
                {cars.map(c => (
                    <Link key={c.id} to={{ pathname: `/writeReport`, state: c }} className="text-center text-lg font-semibold shadow-md border border-blue-200 rounded-lg bg-gray-200 w-3/4 md:w-1/4 lg:w-1/4 m-2 py-2 select-none cursor-pointer">
                        <div className="text-xl text-blue-700 font-normal">الماركة {c.brand}</div>
                        <div className="text-blue-300">الموديل {c.model}</div>
                        <div className="text-blue-300">سنة الصنع {c.year}</div>
                        <div className="text-blue-300">اللوحة {c.plateNo} - {c.plateType}</div>
                    </Link>
                ))}
            </div>
            {cars.length <= 0 &&
                <div className="text-center font-normal text-xl m-4">لا توجد عجلات جاهزة لكتابة التقرير</div>
            }
        </div>
    )
}